<template>
  <div class="modern-dashboard">
    <!-- 页面标题 -->
    <div class="dashboard-header">
      <div class="header-content">
        <div class="title-section">
          <h1 class="dashboard-title">仪表盘</h1>
        </div>
        <div class="welcome-section">
          <p class="welcome-text">欢迎回来,{{ user.name || '系统管理员' }}!今天是{{ currentDate }}</p>
        </div>
        <div class="header-actions">
          <button class="action-btn">
            <a-icon type="user" />
            达人库
          </button>
          <button class="action-btn primary">
            <a-icon type="play-circle" />
            创建项目
          </button>
        </div>
      </div>
    </div>

    <!-- KPI 卡片 -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <div class="kpi-icon users-icon">
          <a-icon type="user" />
        </div>
        <div class="kpi-content">
          <div class="kpi-number">{{ stats.totalInfluencers }}</div>
          <div class="kpi-label">总达人数量</div>
          <div class="kpi-description">平台注册达人总数</div>
          <div class="kpi-trend positive">
            <a-icon type="arrow-up" />
            +12% 较上月
          </div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon projects-icon">
          <a-icon type="line-chart" />
        </div>
        <div class="kpi-content">
          <div class="kpi-number">{{ stats.activeProjects }}</div>
          <div class="kpi-label">活跃项目</div>
          <div class="kpi-description">正在进行的项目</div>
          <div class="kpi-trend positive">
            <a-icon type="arrow-up" />
            +5% 较上月
          </div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon roles-icon">
          <a-icon type="team" />
        </div>
        <div class="kpi-content">
          <div class="kpi-number">{{ stats.collaboratingInfluencers }}</div>
          <div class="kpi-label">合作达人</div>
          <div class="kpi-description">本月合作达人数</div>
          <div class="kpi-trend positive">
            <a-icon type="arrow-up" />
            +8% 较上月
          </div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon departments-icon">
          <a-icon type="line-chart" />
        </div>
        <div class="kpi-content">
          <div class="kpi-number">{{ stats.monthlyROI }}</div>
          <div class="kpi-label">本月ROI</div>
          <div class="kpi-description">投资回报率</div>
          <div class="kpi-trend positive">
            <a-icon type="arrow-up" />
            +15% 较上月
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 最近项目 -->
      <div class="content-card">
        <div class="card-header">
          <div class="card-title">
            <a-icon type="line-chart" />
            <span>最近项目</span>
          </div>
          <div class="card-subtitle">查看最新的营销项目进展</div>
        </div>
        <div class="card-content">
          <div class="project-table">
            <div class="table-header">
              <div class="col">项目名称</div>
              <div class="col">客户</div>
              <div class="col">状态</div>
              <div class="col">进度</div>
              <div class="col">预算</div>
            </div>
            <div class="table-body">
              <div class="table-row" v-for="project in recentProjects" :key="project.id">
                <div class="col project-name">{{ project.name }}</div>
                <div class="col">{{ project.client }}</div>
                <div class="col">
                  <span class="status-badge" :class="project.status">{{ project.statusText }}</span>
                </div>
                <div class="col">
                  <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: project.progress + '%' }"></div>
                  </div>
                  <span class="progress-text">{{ project.progress }}%</span>
                </div>
                <div class="col">{{ project.budget }}</div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <a-button type="link" @click="$router.push('/system')">查看所有项目</a-button>
          </div>
        </div>
      </div>

      <!-- 热门达人 -->
      <div class="content-card">
        <div class="card-header">
          <div class="card-title">
            <a-icon type="user" />
            <span>热门达人</span>
          </div>
          <div class="card-subtitle">表现优秀的合作达人</div>
        </div>
        <div class="card-content">
          <div class="user-list">
            <div class="user-item" v-for="influencer in popularInfluencers" :key="influencer.id">
              <div class="user-avatar">{{ influencer.name.charAt(0) }}</div>
              <div class="user-info">
                <div class="user-name">{{ influencer.name }}</div>
                <div class="user-stats">{{ influencer.followers }}万粉丝 • {{ influencer.engagementRate }}%互动率</div>
                <div class="user-category">
                  <span class="category-tag">{{ influencer.category }}</span>
                  <span class="project-count">{{ influencer.projectCount }}个项目</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <a-button type="link" @click="$router.push('/system')">查看达人库</a-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 快速访问卡片 -->
    <div class="quick-access">
      <div class="access-card" @click="$router.push('/system')">
        <div class="access-icon">
          <a-icon type="user" />
        </div>
        <div class="access-content">
          <div class="access-title">达人资源库</div>
          <div class="access-description">管理和搜索达人资源</div>
          <div class="access-metric">
            <a-icon type="eye" />
            {{ stats.totalInfluencers }}个达人
          </div>
        </div>
      </div>

      <div class="access-card" @click="$router.push('/menuRole')">
        <div class="access-icon">
          <a-icon type="play-circle" />
        </div>
        <div class="access-content">
          <div class="access-title">项目管理</div>
          <div class="access-description">创建和管理营销项目</div>
          <div class="access-metric">
            <a-icon type="line-chart" />
            {{ stats.activeProjects }}个活跃项目
          </div>
        </div>
      </div>

      <div class="access-card" @click="$router.push('/system')">
        <div class="access-icon">
          <a-icon type="dollar" />
        </div>
        <div class="access-content">
          <div class="access-title">财务管理</div>
          <div class="access-description">预算和费用管理</div>
          <div class="access-metric">
            <a-icon type="line-chart" />
            {{ stats.monthlyROI }} ROI
          </div>
        </div>
      </div>

      <div class="access-card" @click="$router.push('/system')">
        <div class="access-icon">
          <a-icon type="calendar" />
        </div>
        <div class="access-content">
          <div class="access-title">日程管理</div>
          <div class="access-description">查看项目时间线</div>
          <div class="access-metric">
            <a-icon type="line-chart" />
            5个待办事项
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  computed: {
    user() {
      return this.$store.state.user || { name: '系统管理员' };
    },
    currentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const weekday = weekdays[now.getDay()];
      return `${year}年${month}月${day}日${weekday}`;
    }
  },
  data() {
    return {
      stats: {
        totalInfluencers: '2,847',
        activeProjects: 23,
        collaboratingInfluencers: 156,
        monthlyROI: '3.2x'
      },
      recentProjects: [
        {
          id: 1,
          name: '春季美妆推广',
          client: '美丽集团',
          status: 'progress',
          statusText: '进行中',
          progress: 75,
          budget: '50万'
        },
        {
          id: 2,
          name: '夏日服装营销',
          client: '时尚品牌',
          status: 'preparing',
          statusText: '筹备中',
          progress: 25,
          budget: '80万'
        },
        {
          id: 3,
          name: '健康食品推广',
          client: '健康生活',
          status: 'completed',
          statusText: '已完成',
          progress: 100,
          budget: '30万'
        }
      ],
      popularInfluencers: [
        {
          id: 1,
          name: '小美生活',
          followers: 125,
          engagementRate: 8.5,
          category: '美妆',
          projectCount: 12
        },
        {
          id: 2,
          name: '时尚达人',
          followers: 89,
          engagementRate: 7.2,
          category: '时尚',
          projectCount: 8
        },
        {
          id: 3,
          name: '健康专家',
          followers: 156,
          engagementRate: 9.1,
          category: '健康',
          projectCount: 15
        }
      ]
    };
  },
  mounted() {
    this.loadStats();
  },
  methods: {
    loadStats() {
      // 这里可以加载真实的统计数据
      // 暂时使用模拟数据
      console.log('Dashboard stats loaded:', this.stats);
    }
  }
};
</script>

<style scoped>
/* 主容器 */
.modern-dashboard {
  padding: 16px;
  background: #f8fafc;
  height: 100vh;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.modern-dashboard * {
  box-sizing: border-box;
}

/* 页面标题 */
.dashboard-header {
  margin-bottom: 24px;
  flex-shrink: 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.welcome-section {
  flex: 1;
}

.dashboard-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
  letter-spacing: -0.025em;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.action-btn.primary {
  background: #1a202c;
  color: white;
  border-color: #1a202c;
}

.action-btn.primary:hover {
  background: #374151;
  border-color: #374151;
}

/* KPI 卡片网格 */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
}

.kpi-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  height: 120px;
  display: flex;
  flex-direction: column;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.kpi-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #64748b;
  margin-bottom: 12px;
  background: #f8fafc;
}

.users-icon { background: #f8fafc; color: #64748b; }
.projects-icon { background: #f8fafc; color: #64748b; }
.roles-icon { background: #f8fafc; color: #64748b; }
.departments-icon { background: #f8fafc; color: #64748b; }

.kpi-content {
  flex: 1;
}

.kpi-number {
  font-size: 28px;
  font-weight: 800;
  color: #1a202c;
  line-height: 1;
  margin-bottom: 4px;
  letter-spacing: -0.025em;
}

.kpi-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.kpi-description {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}

.kpi-trend {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.kpi-trend.positive {
  color: #10b981;
}

/* 主要内容区域 */
.main-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
  flex: 1;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  height: 300px;
}

.content-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.card-header {
  padding: 16px 16px 12px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 4px;
}

.card-title i {
  color: #3b82f6;
  font-size: 16px;
}

.card-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.card-content {
  padding: 16px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.card-footer {
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
  background: #f8fafc;
  flex-shrink: 0;
}

/* 项目表格 */
.project-table {
  width: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.table-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  flex: 1;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr;
  gap: 16px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.table-row:last-child {
  border-bottom: none;
}

.col {
  font-size: 13px;
}

.project-name {
  font-weight: 600;
  color: #1a202c;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.status-badge.progress {
  background: #d1fae5;
  color: #059669;
}

.status-badge.preparing {
  background: #fef3c7;
  color: #d97706;
}

.status-badge.completed {
  background: #dbeafe;
  color: #1d4ed8;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 4px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 11px;
  color: #6b7280;
  font-weight: 600;
}

/* 用户列表 */
.user-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow-y: auto;
}

.user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 4px;
}

.user-stats {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 4px;
}

.user-category {
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
  background: #e2e8f0;
  color: #64748b;
}

.project-count {
  font-size: 10px;
  color: #9ca3af;
}

/* 快速访问卡片 */
.quick-access {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  height: 120px;
}

.access-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.access-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  border-color: #3b82f6;
}

.access-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 18px;
  color: #64748b;
  transition: all 0.2s ease;
}

.access-card:hover .access-icon {
  background: #3b82f6;
  color: white;
}

.access-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 6px;
}

.access-description {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.4;
}

.access-metric {
  font-size: 12px;
  font-weight: 700;
  color: #3b82f6;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .quick-access {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .modern-dashboard {
    padding: 12px;
  }
  
  .kpi-grid {
    grid-template-columns: 1fr;
  }
  
  .main-content {
    grid-template-columns: 1fr;
  }
  
  .quick-access {
    grid-template-columns: 1fr;
  }
  
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .table-header {
    display: none;
  }
  
  .table-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
